import { Box, MenuItem } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { Menu, MenuButton } from '@retail/components';
import { ChevronDownIcon, ChevronUpIcon } from '@sanity/icons';

interface Props {
  exportMarkups: () => void;
  exportSalesPriceConditions: () => void;
  height?: number;
}

export const ExportConditionsMenu = ({ exportMarkups, exportSalesPriceConditions }: Props) => {
  const t = useCalculusTFunction();

  return (
    <Menu>
      {({ isOpen, onClose }) => (
        <Box>
          <MenuButton
            size="small"
            variant="outlined"
            color="secondary"
            endIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          >
            {t('calculus.actions.export')}
          </MenuButton>

          <MenuItem
            key="csv"
            onClick={() => {
              exportMarkups();
              onClose();
            }}
            sx={{
              backgroundColor: 'grey.300',
            }}
          >
            {t('calculus.actions.exportMarkups')}
          </MenuItem>

          <MenuItem
            key="excel"
            onClick={() => {
              exportSalesPriceConditions();
              onClose();
            }}
            sx={{
              backgroundColor: 'grey.300',
            }}
          >
            {t('calculus.actions.export')}
          </MenuItem>
        </Box>
      )}
    </Menu>
  );
};
